import {
  IndexTable,
  IndexFilters,
  useSetIndexFiltersMode,
  useIndexResourceState,
  Text,
  Page,
  useBreakpoints,
  Thumbnail,
  Tooltip,
  Link,
  Banner,
  Frame,
  Modal,
  TextField,
  Spinner,
  Select,
  TextContainer,
  Button,
  Badge,
} from "@shopify/polaris";
// import { Modal, TitleBar, useAppBridge } from "@shopify/app-bridge-react";

import { useState, useEffect, useCallback, useRef } from "react";
import icon from "../icons/icons8-google-48.png";
import warningIcon from "../icons/warning.png";
import checkedIcon from "../icons/checked.png";
import { useLocation, useNavigate } from "react-router-dom";
import productsData from "../data/products";
import { getProductImageAlt, getProductImageUrl } from "../utils/productMedia";

function DataTable3(props) {
  // const shopify = useAppBridge();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [submittedProducts, setSubmittedProducts] = useState([]);
  const [excludedProducts, setExcludedProducts] = useState([]);
  const [ineligibleProducts, setIneligibleProducts] = useState([]);
  const [allFeedProducts, setAllFeedProducts] = useState([]);
  const [alreadyListedProducts, setAlreadyListedProducts] = useState([]);
  const [googleProducts, setGoogleProducts] = useState([]);
  const [activeProductsCount, setActiveProductsCount] = useState(0);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [loading, setLoading] = useState(true);
  const [tabLoading, setTabLoading] = useState(false);
  const [selected, setSelected] = useState(0);
  const [cursor, setCursor] = useState(null);
  const [queryValue, setQueryValue] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [value, setValue] = useState("");
  const [modal, setModal] = useState(null);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [syncLoading, setSyncLoading] = useState(false);
  const [syncingProductId, setSyncingProductId] = useState(null);
  const [refreshError, setRefreshError] = useState(false);
  const [textFieldValue, setTextFieldValue] = useState("");
  // Modal state for issues
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [selectedErrors, setSelectedErrors] = useState([]);
  const [selectedWarnings, setSelectedWarnings] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [filterParams, setFilterParams] = useState({
    // ads_grouping: [],
    // ads_label: [],
    adult: [],
    age_group: [],
    product_condition: [],
    color: [],
    default_cogs: [],
    publishing_error: [],
    gender: [],
    google_product_category: [],
    default_material: [],
    default_pattern: [],
    custom_product: [],
    product_type: [],
    channel_submission_control: [],
    promotions: [],
    return_policy_label: [],
    shipping_label: [],
    default_size: [],
    size_system: [],
    size_type: [],
    tags: [],
    unit_pricing_measure: [],
    unit_pricing_base_measure: [],
    brand: [],
  });

  const [banners, setBanners] = useState([]);
  const [sortSelected, setSortSelected] = useState(["product asc"]);
  const [gmcImportSummary, setGmcImportSummary] = useState(null);
  const [gmcPresenceByProductId, setGmcPresenceByProductId] = useState({});
  const [gmcImportLoading, setGmcImportLoading] = useState(false);
  const gmcImportAttemptedRef = useRef(false);
  const { mode, setMode } = useSetIndexFiltersMode();
  const location = useLocation();

  const handleChange = useCallback((newValue) => setValue(newValue), []);

  const urlParams = new URLSearchParams(location.search);
  const paramValue = urlParams.get("shop");

  const mapFeedEntryToProduct = (entry, feedStatus = "not_synced") => {
    const node = entry?.node || entry;

    return {
      id: node.productId || node.id,
      product: node.title,
      category: node.productType,
      errors: node.errors || [],
      warnings: node.warnings || [],
      image: getProductImageUrl(node),
      tooltip: getProductImageAlt(node),
      submitted: feedStatus === "submitted",
      feedStatus,
      variants: node.variants || { edges: [] },
      description: node.description || "",
      metafields: node.metafields || [],
      importedFromGmc: Boolean(node.importedFromGmc),
      gmcStatus: node.gmcStatus || null,
    };
  };

  const buildAlreadyListedProducts = useCallback(
    (matchedProductIds = {}, sourceProducts = []) => {
      const byId = new Map(
        (sourceProducts || []).map((product) => [product.id, product]),
      );

      return Object.entries(matchedProductIds || {}).map(
        ([productId, presence]) => {
          const existing = byId.get(productId);
          const presenceImage =
            (typeof presence?.image === "string" && presence.image) || "";

          if (existing) {
            return {
              ...existing,
              image: existing.image || presenceImage || "",
              alreadyOnGmc: true,
              gmcPresence: presence,
              feedStatus: existing.feedStatus || "not_synced",
            };
          }

          return {
            id: productId,
            product: presence?.title || "Shopify product",
            category: "",
            errors: [],
            warnings: [],
            image: presenceImage,
            tooltip: "",
            submitted: false,
            feedStatus: "not_synced",
            variants: { edges: [] },
            description: "",
            metafields: [],
            alreadyOnGmc: true,
            gmcPresence: presence,
          };
        },
      );
    },
    [],
  );

  const hydrateAlreadyListedImages = useCallback(
    async (listedProducts = []) => {
      if (!paramValue || !listedProducts.length) return listedProducts;

      const missingIds = listedProducts
        .filter((product) => !product?.image)
        .map((product) => product.id)
        .filter(Boolean);

      if (!missingIds.length) return listedProducts;

      try {
        const byId = new Map();
        for (let i = 0; i < missingIds.length; i += 100) {
          const chunk = missingIds.slice(i, i + 100);
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/api/shopify/store/products/by-ids?shop=${paramValue}`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ productIds: chunk }),
            },
          );
          const data = await response.json();
          if (!response.ok || data.status === false) {
            throw new Error(data.message || "Failed to hydrate product images");
          }
          (data.data?.products || []).forEach((product) => {
            byId.set(product.id, product);
          });
        }

        if (!byId.size) return listedProducts;

        return listedProducts.map((product) => {
          const preview = byId.get(product.id);
          if (!preview) return product;
          return {
            ...product,
            product: product.product || preview.title || "Shopify product",
            image: product.image || preview.image || "",
            description: product.description || preview.description || "",
            category: product.category || preview.productType || "",
            variants:
              product.variants?.edges?.length > 0
                ? product.variants
                : preview.variants || { edges: [] },
          };
        });
      } catch (error) {
        console.error("Failed to hydrate already-listed images:", error);
        return listedProducts;
      }
    },
    [paramValue],
  );

  const applyGmcPresence = useCallback(
    async (summary, sourceProducts = []) => {
      if (!summary) {
        setGmcImportSummary(null);
        setGmcPresenceByProductId({});
        setAlreadyListedProducts([]);
        return;
      }
      const matchedProductIds = summary.matchedProductIds || {};
      setGmcImportSummary(summary);
      setGmcPresenceByProductId(matchedProductIds);

      const listed = buildAlreadyListedProducts(
        matchedProductIds,
        sourceProducts,
      );
      setAlreadyListedProducts(listed);

      const hydrated = await hydrateAlreadyListedImages(listed);
      if (hydrated !== listed) {
        setAlreadyListedProducts(hydrated);
      }
    },
    [buildAlreadyListedProducts, hydrateAlreadyListedImages],
  );

  const handleImportGmcProducts = useCallback(
    async ({ force = false, silent = false } = {}) => {
      if (!paramValue) return null;
      setGmcImportLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/google/import-gmc-products?shop=${paramValue}${
            force ? "&force=true" : ""
          }`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ force }),
          },
        );
        const data = await response.json();
        if (!response.ok || data.status === false) {
          throw new Error(data.message || "Failed to scan GMC products");
        }

        const summary = data.data?.summary || null;
        applyGmcPresence(summary, allFeedProducts);
        gmcImportAttemptedRef.current = true;

        if (!silent && summary) {
          const activeCount =
            summary.activeShopifyProductCount ||
            summary.shopifyProductCount ||
            activeProductsCount ||
            0;
          const matchedCount =
            summary.matchedShopifyProducts || summary.matchedProducts || 0;
          setBanners((prev) => [
            {
              id: `gmc-import-${Date.now()}`,
              status: "info",
              title: "Active Shopify products already listed on GMC",
              content: `GMC has ${summary.gmcTotal || 0} products. ${matchedCount} of your ${activeCount} Active Shopify products are already listed there (outside this app's sync). ${
                summary.unmatchedGmcOffers || summary.unmatchedOffers || 0
              } GMC offers could not be matched to Shopify.`,
            },
            ...prev.filter((banner) => !String(banner.id || "").startsWith("gmc-import-")),
          ]);
        }

        return data.data;
      } catch (error) {
        console.error("GMC scan failed:", error);
        if (!silent) {
          setBanners((prev) => [
            {
              id: `gmc-import-error-${Date.now()}`,
              status: "critical",
              title: "Could not scan GMC products",
              content: error.message,
            },
            ...prev,
          ]);
        }
        return null;
      } finally {
        setGmcImportLoading(false);
      }
    },
    [paramValue, applyGmcPresence, allFeedProducts, activeProductsCount],
  );

  const fetchProducts = async (
    cursor = null,
    searchQuery = null,
    isPagination = false,
  ) => {
    setLoading(true);
    try {
      const apiUrl = `${
        process.env.REACT_APP_API_URL
      }/api/shopify/store/products?shop=${paramValue}${
        cursor ? `&cursor=${cursor}` : ""
      }${searchQuery ? `&query=${encodeURIComponent(searchQuery)}` : ""}`;
      const response = await fetch(apiUrl);
      const data = await response.json();

      if (data.status) {
        const productsFeed = data.data.products_feed || {};
        const feedStatusByProductId = new Map();
        ["submitted", "excluded", "ineligible"].forEach((status) => {
          (productsFeed[status] || []).forEach((entry) => {
            const productId = entry.productId || entry.node?.id;
            if (productId) feedStatusByProductId.set(productId, status);
          });
        });

        const presenceMap =
          (!isPagination && data.data.gmc_presence?.matchedProductIds) ||
          gmcPresenceByProductId ||
          {};

        // Map Shopify products
        const newProducts = data.data.products.map(({ node }) => ({
          id: node.id,
          product: node.title,
          category: node.productType,
          errors: node.errors,
          warnings: node.warnings || [],
          image: getProductImageUrl(node),
          tooltip: getProductImageAlt(node),
          submitted: feedStatusByProductId.get(node.id) === "submitted",
          feedStatus: feedStatusByProductId.get(node.id) || "not_synced",
          variants: node.variants,
          description: node.description ? node.description : "",
          metafields: node.metafields || [],
          alreadyOnGmc: Boolean(presenceMap[node.id]),
          gmcPresence: presenceMap[node.id] || null,
        }));
        if (newProducts.length > 0) {
          // Debug warnings presence from backend validation
          // eslint-disable-next-line no-console
        }

        // Helper to avoid duplicates by id
        const addUniqueProducts = (existingProducts, newProducts) => {
          return [
            ...existingProducts,
            ...newProducts.filter(
              (np) => !existingProducts.some((ep) => ep.id === np.id),
            ),
          ];
        };

        // On first render (not pagination), set feeds from products_feed
        if (!isPagination && data.data.products_feed) {
          // Submitted
          const submittedProducts =
            data.data.products_feed.submitted?.map((entry) =>
              mapFeedEntryToProduct(entry, "submitted"),
            ) || [];
          setSubmittedProducts(submittedProducts);

          // Excluded
          const excludedProducts =
            data.data.products_feed.excluded?.map((entry) =>
              mapFeedEntryToProduct(entry, "excluded"),
            ) || [];
          setExcludedProducts(excludedProducts);

          // Ineligible
          const ineligibleProducts =
            data.data.products_feed.ineligible?.map((entry) =>
              mapFeedEntryToProduct(entry, "ineligible"),
            ) || [];
          setIneligibleProducts(ineligibleProducts);

          // All Products = Active Shopify products only (not drafts / feed-only)
          setAllFeedProducts(newProducts);
          if (typeof data.data.activeProductsCount === "number") {
            setActiveProductsCount(data.data.activeProductsCount);
          }

          if (data.data.gmc_presence) {
            applyGmcPresence(data.data.gmc_presence, newProducts);
          } else if (!gmcImportAttemptedRef.current && !gmcImportLoading) {
            gmcImportAttemptedRef.current = true;
            const importResult = await handleImportGmcProducts({
              force: true,
              silent: false,
            });
            if (importResult && !importResult.skipped) {
              await fetchProducts(null, searchQuery, false);
              return;
            }
          }
        }

        // On pagination, append more Active Shopify products
        if (isPagination && data.data.products_feed) {
          const submittedProducts =
            data.data.products_feed.submitted?.map((entry) =>
              mapFeedEntryToProduct(entry, "submitted"),
            ) || [];
          setSubmittedProducts(submittedProducts);

          const excludedProducts =
            data.data.products_feed.excluded?.map((entry) =>
              mapFeedEntryToProduct(entry, "excluded"),
            ) || [];
          setExcludedProducts(excludedProducts);

          const ineligibleProducts =
            data.data.products_feed.ineligible?.map((entry) =>
              mapFeedEntryToProduct(entry, "ineligible"),
            ) || [];
          setIneligibleProducts(ineligibleProducts);

          setAllFeedProducts((prevProducts) =>
            addUniqueProducts(prevProducts, newProducts),
          );
          if (typeof data.data.activeProductsCount === "number") {
            setActiveProductsCount(data.data.activeProductsCount);
          }
        }

        setProducts((prevProducts) =>
          isPagination
            ? addUniqueProducts(prevProducts, newProducts)
            : newProducts,
        );
        setHasNextPage(data.data.pageInfo.hasNextPage);
        setCursor(data.data.pageInfo.endCursor);
        // After all product arrays are set, fetch and merge product errors
        await fetchProductErrorsAndMerge();
      } else {
        console.error("Failed to fetch products:", data.message);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleTextFieldChange = useCallback((value) => {
    setTextFieldValue(value);
  }, []);

  const fetchBanners = async () => {
    try {
      const urlParams = new URLSearchParams(location.search);
      const paramValue = urlParams.get("shop");
      const apiUrl = `${process.env.REACT_APP_API_URL}/api/google/auth/account/statuses?shop=${paramValue}`;
      const response = await fetch(apiUrl);
      const data = await response.json();
      if (data?.data?.length > 0) {
        const newBanners = data.data.map((issue) => ({
          status: issue.severity,
          title: issue.title,
          content: (
            <>
              <p>
                Your Google Merchant Center account has faced a suspension due
                to Misrepresentation policy violation. This may have occurred
                prior to installing the Google Feed App.{" "}
                {issue.documentation &&
                  'For guidance on resolving this issue, please click on the button "Learn More"'}
              </p>
              {issue.documentation && (
                <div style={{ marginTop: "5px" }}>
                  <Button variant="primary" url={issue.documentation} external>
                    Learn more
                  </Button>
                </div>
              )}
            </>
          ),
        }));
        setBanners(newBanners);
      }

      // Fetch upload reminder banner
      try {
        const reminderRes = await fetch(
          `${process.env.REACT_APP_API_URL}/api/shopify/product-check/upload-reminder?shop=${paramValue}`,
        );
        const reminder = await reminderRes.json();
        if (reminder?.data?.needsReminder) {
          setBanners((prev) => [
            ...prev,
            {
              status: "warning",
              title: "No product uploads in the last 7 days",
              content: (
                <>
                  <p>
                    It looks like you haven't uploaded any new products in the
                    past 7 days. If this is unexpected, consider submitting
                    products now to keep your feed fresh.
                  </p>
                  <div style={{ marginTop: "5px" }}>
                    <Button
                      onClick={() => navigate(`/products?shop=${paramValue}`)}
                    >
                      Go to Products
                    </Button>
                  </div>
                </>
              ),
            },
          ]);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("Failed to fetch upload reminder", e);
      }
    } catch (error) {
      console.error("Error fetching banners", error);
    }
  };

  useEffect(() => {
    const hasSynced = products.some((p) => p.justSynced);

    if (hasSynced) {
      setIsProcessing(true);

      const timer = setTimeout(() => {
        setProducts((prev) => prev.map((p) => ({ ...p, justSynced: false })));
        setIsProcessing(false); // Hide banner
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [products]);

  useEffect(() => {
    fetchProducts();
    let merchantId = props.merchantInfo ? props.merchantInfo.id : "";
    // setBanners([
    //   {
    //     status: "critical",
    //     title: "Action Required: Disable Password Protection",
    //     content: (
    //       <>
    //         <p>
    //           Oops! Your store is currently password-protected. Please make sure
    //           your store is publicly accessible before submitting products to
    //           any marketing platform. Otherwise, all submitted products will be
    //           disapproved.
    //         </p>
    //         <div style={{ marginTop: "5px" }}>
    //           <Button>Dismiss</Button>
    //         </div>
    //       </>
    //     ),
    //   },
    // ]);
    fetchBanners();
  }, []);

  const handleNextPage = () => {
    if (hasNextPage) {
      fetchProducts(cursor, null, true);
    }
  };

  const handleDismissBanner = (banner) => {
    let updatedBanner = banners.filter((obj) => obj.title != banner.title);
    setBanners(updatedBanner);
  };

  const handleSyncProducts = async ({ productIds = [], syncAll = false }) => {
    try {
      setSyncLoading(true);
      if (productIds.length === 1) {
        setSyncingProductId(productIds[0]);
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/shopify/store/products/sync?shop=${paramValue}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ products: productIds, syncAll }),
        },
      );
      const data = await response.json();

      if (!response.ok || data.status === false) {
        const migrationMessage = data.message?.includes("Content API")
          ? "Google API migration required. Enable Merchant API and configure a product data source."
          : data.message;
        throw new Error(migrationMessage || "Failed to sync products");
      }

      const googleErrors = data.data?.google_errors || [];
      const syncedCount = data.data?.synced || 0;
      const failedCount = data.data?.failed || 0;
      const syncContent = googleErrors.length
        ? `${syncedCount} product(s) accepted by Google, ${failedCount} failed: ${googleErrors[0].messages.join(", ")}`
        : data.message || "Products were submitted to Google Merchant Center.";

      setBanners((prev) => [
        {
          status: googleErrors.length ? "warning" : "success",
          title: googleErrors.length
            ? "Product sync needs attention"
            : syncAll
              ? "All products sync completed"
              : "Product synced",
          content: syncContent,
        },
        ...prev.filter(
          (banner) =>
            banner.title !== "All products sync completed" &&
            banner.title !== "Product synced" &&
            banner.title !== "Product sync needs attention",
        ),
      ]);

      await fetchProducts(null, null, false);
      return data;
    } catch (error) {
      console.error("Error syncing products:", error);
      setBanners((prev) => [
        {
          status: "critical",
          title: "Product sync failed",
          content: error.message || "Unable to sync products right now.",
        },
        ...prev.filter((banner) => banner.title !== "Product sync failed"),
      ]);
      throw error;
    } finally {
      setSyncLoading(false);
      setSyncingProductId(null);
    }
  };

  const resourceName = {
    singular: "product",
    plural: "products",
  };

  const openModalAction = (label, content) => {
    setOpenModal(true);
    const modalContent = {
      title: label,
      content: `Are you sure you want to ${label.toLowerCase()}?`,
    };
    if (label !== "Exclude Products") {
      modalContent.inputField = true;
    }
    setModal(modalContent);
  };

  const bulkActions = [
    {
      content: <Link removeUnderline>Exlude Prouducts</Link>,
      onAction: () => openModalAction("Exclude Products"),
    },
    // {
    //   content: <Link removeUnderline>Assign Ads Grouping</Link>,
    //   onAction: () => openModalAction("Assign Ads Grouping"),
    // },
    // {
    //   content: <Link removeUnderline>Assign Ads Label</Link>,
    //   onAction: () => openModalAction("Assign Ads Label"),
    // },
    // {
    //   content: <Link removeUnderline>Assign Age Group</Link>,
    //   onAction: () => openModalAction("Assign Age Group"),
    // },
    {
      content: <Link removeUnderline>Assign Color for Feed</Link>,
      onAction: () => openModalAction("Assign Color for Feed"),
    },
    // {
    //   content: <Link removeUnderline>Assign Cost Of Goods Sold for Feed</Link>,
    //   onAction: () => openModalAction("Assign Cost Of Goods Sold for Feed"),
    // },
    {
      content: <Link removeUnderline>Assign Custom Label 0</Link>,
      onAction: () => openModalAction("Assign Custom Label 0"),
    },
    {
      content: <Link removeUnderline>Assign Custom Label 1</Link>,
      onAction: () => openModalAction("Assign Custom Label 1"),
    },
    {
      content: <Link removeUnderline>Assign Custom Label 2</Link>,
      onAction: () => openModalAction("Assign Custom Label 2"),
    },
    {
      content: <Link removeUnderline>Assign Custom Label 3</Link>,
      onAction: () => openModalAction("Assign Custom Label 3"),
    },
    {
      content: <Link removeUnderline>Assign Custom Label 4</Link>,
      onAction: () => openModalAction("Assign Custom Label 4"),
    },
    // {
    //   content: <Link removeUnderline>Assign Gender</Link>,
    //   onAction: () => openModalAction("Assign Gender"),
    // },
    // {
    //   content: <Link removeUnderline>Assign Google Product Category</Link>,
    //   onAction: () => openModalAction("Assign Google Product Category"),
    // },
    {
      content: <Link removeUnderline>Assign Material for Feed</Link>,
      onAction: () => openModalAction("Assign Material for Feed"),
    },
    // {
    //   content: <Link removeUnderline>Assign or Remove Promotions</Link>,
    //   onAction: () => openModalAction("Assign or Remove Promotions"),
    // },
    {
      content: <Link removeUnderline>Assign Pattern for Feed</Link>,
      onAction: () => openModalAction("Assign Pattern for Feed"),
    },
    // {
    //   content: <Link removeUnderline>Assign Product Condition</Link>,
    //   onAction: () => openModalAction("Assign Product Condition"),
    // },
    // {
    //   content: <Link removeUnderline>Assign Product Type</Link>,
    //   onAction: () => openModalAction("Assign Product Type"),
    // },
    // {
    //   content: <Link removeUnderline>Assign Return Policy Label</Link>,
    //   onAction: () => openModalAction("Assign Return Policy Label"),
    // },
    {
      content: <Link removeUnderline>Assign Shipping Label</Link>,
      onAction: () => openModalAction("Assign Shipping Label"),
    },
    // {
    //   content: <Link removeUnderline>Assign Size for Feed</Link>,
    //   onAction: () => openModalAction("Assign Size for Feed"),
    // },
    // {
    //   content: <Link removeUnderline>Assign Size System</Link>,
    //   onAction: () => openModalAction("Assign Size System"),
    // },
    // {
    //   content: <Link removeUnderline>Assign Size Type</Link>,
    //   onAction: () => openModalAction("Assign Size Type"),
    // },
    {
      content: <Link removeUnderline>Assign Tax Category</Link>,
      onAction: () => openModalAction("Assign Tax Category"),
    },
    // {
    //   content: <Link removeUnderline>Assign Unit Pricing Measure</Link>,
    //   onAction: () => openModalAction("Assign Unit Pricing Measure"),
    // },
    // {
    //   content: <Link removeUnderline>Assign Unit Pricing Base Measure</Link>,
    //   onAction: () => openModalAction("Assign Unit Pricing Base Measure"),
    // },
    // {
    //   content: (
    //     <Link removeUnderline>Change Identifiers Submission Controls</Link>
    //   ),
    //   onAction: () => openModalAction("Change Identifiers Submission Controls"),
    // },
    // {
    //   content: <Link removeUnderline>Channel Submission Control</Link>,
    //   onAction: () => openModalAction("Channel Submission Control"),
    // },
    // {
    //   content: <Link removeUnderline>Export for Supplemental Feed</Link>,
    //   onAction: () => openModalAction("Export for Supplemental Feed"),
    // },
    // {
    //   content: (
    //     <Link removeUnderline>Export for Title, Description and Type Edit</Link>
    //   ),
    //   onAction: () => openModalAction("Export for Title, Description and Type Edit"),
    // },
    // {
    //   content: <Link removeUnderline>Mark as Adult-Oriented Product</Link>,
    //   onAction: () => openModalAction("Mark as Adult-Oriented Product"),
    // },
    // {
    //   content: <Link removeUnderline>Sync Meta Fields</Link>,
    //   onAction: () => openModalAction("Sync Meta Fields"),
    // },
  ];

  const updateErrors = async () => {
    setRefreshError(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/google/product-errors?shop=${paramValue}`,
      );
      const data = await response.json();

      if (data.data) {
        // Filter disapproved products and map their errors
        const disapprovedProducts = data.data.errors.filter(
          (product) =>
            product.itemLevelIssues.some(
              (issue) => issue.servability === "disapproved",
            ) ||
            product.productLevelIssues.some(
              (issue) => issue.servability === "disapproved",
            ),
        );

        // Update products with errors
        const updatedProducts = products.map((product) => {
          // Find corresponding disapproved product by matching ID
          const merchantProduct = disapprovedProducts.find(
            (mp) => mp.productId.split(":")[3] === product.id.split("/")[4],
          );

          if (merchantProduct) {
            // Combine all error descriptions from both item and product level issues
            const errorDescriptions = [
              ...(merchantProduct.itemLevelIssues || []),
              ...(merchantProduct.productLevelIssues || []),
            ]
              .filter((issue) => issue.servability === "disapproved")
              .map((issue) => ({
                description: issue.description,
                detail: issue.detail,
                documentation: issue.documentation,
              }));

            return {
              ...product,
              errors: errorDescriptions.map((error) => `${error.description}`),
            };
          }
          return product;
        });

        setProducts(updatedProducts);
      }
    } catch (error) {
      console.error("Error fetching product errors:", error);
    } finally {
      // Remove loading state after 2 seconds
      setTimeout(() => {
        setRefreshError(false);
      }, 2000);
    }
  };

  const headings = [
    { title: "Product" },
    { title: "" },
    { title: "Google Product Category" },
    {
      title: (
        <div>
          <img
            src={icon}
            alt="Google"
            style={{ width: "16px", height: "16px" }}
          />
        </div>
      ),
    },
    {
      title: (
        <>
          Error from Merchant Center
          <span
            style={{
              color: "blue",
              fontSize: "9px",
              position: "relative",
              left: "3px",
              cursor: "pointer",
            }}
            onClick={updateErrors}
          >
            Refresh Product Errors
          </span>
        </>
      ),
    },
    { title: "Action" },
  ];

  const handleFiltersQueryChange = useCallback(async (value) => {
    setQueryValue(value);
    setLoading(true);
    try {
      if (value != "") {
        const urlParams = new URLSearchParams(location.search);
        const paramValue = urlParams.get("shop");

        const apiUrl = `${
          process.env.REACT_APP_API_URL
        }/api/shopify/store/products?shop=${paramValue}${
          value ? `&searchQuery=${encodeURIComponent(value)}` : ""
        }`;

        const response = await fetch(apiUrl);
        const data = await response.json();

        if (data.status) {
          const newProducts = data.data.products.map(({ node }) => ({
            id: node.id,
            product: node.title,
            category: node.productType,
            errors: node.errors,
            warnings: node.warnings || [],
            image: getProductImageUrl(node),
            tooltip: getProductImageAlt(node),
            submitted: true,
            variants: node.variants,
            description: node.description ? node.description : "",
          }));
          setProducts(newProducts);
          setHasNextPage(data.data.products.pageInfo.hasNextPage);
          setCursor(data.data.products.pageInfo.endCursor);
        } else {
          console.error("Failed to fetch products:", data.message);
        }
      } else {
        fetchProducts();
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const sortOptions = [
    { label: "Product", value: "product asc", directionLabel: "A-Z" },
    { label: "Product", value: "product desc", directionLabel: "Z-A" },
    { label: "Error", value: "error asc", directionLabel: "A-Z" },
    { label: "Error", value: "error desc", directionLabel: "Z-A" },
  ];

  const handleFilterParams = (key, value) => {
    setFilterParams((prevParams) => ({ ...prevParams, [key]: value }));
    filterProducts({ [key]: value });
  };

  const filterProducts = async (filterParams) => {
    setLoading(true);
    try {
      const apiUrl = `${process.env.REACT_APP_API_URL}/api/shopify/filter-products?shop=${paramValue}`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ filters: filterParams }),
      });
      const data = await response.json();
      if (data.status) {
        if (data.data && data.data.products && data.data.products.length > 0) {
          const formattedProducts = data.data.products.map((product) => ({
            id: product.id,
            product: product.title,
            description: product.description,
            image: getProductImageUrl(product),
            variants: product.variants || {},
            description: product.description ? product.description : "",
          }));
          setProducts(formattedProducts);
        } else {
          setProducts([]);
        }
      } else {
        console.error("Failed to fetch filtered products:", data.message);
        setProducts([]);
      }
    } catch (error) {
      console.error("Error fetching filtered products:", error);
      fetchProducts();
    } finally {
      setLoading(false);
    }
  };
  const filters = [
    // {
    //   key: "ads_grouping",
    //   label: "Ads Grouping",
    //   filter: (
    //     <Select
    //       label="Ads Grouping"
    //       labelHidden
    //       options={[
    //         { label: "Not defined (blank)", value: "Not defined (blank)" },
    //       ]}
    //       placeholder="Select Ads Grouping..."
    //       onChange={(value) => handleFilterParams("ads_grouping", value)}
    //       value={
    //         filterParams.ads_grouping?.length ? filterParams.ads_grouping : []
    //       }
    //     />
    //   ),
    //   shortcut: true,
    // },
    // {
    //   key: "ads_label",
    //   label: "Ads Label",
    //   filter: (
    //     <Select
    //       label="Ads Label"
    //       labelHidden
    //       options={[
    //         { label: "Not defined (blank)", value: "Not defined (blank)" },
    //       ]}
    //       placeholder="Select Ads Label..."
    //       onChange={(value) => handleFilterParams("ads_label", value)}
    //       value={filterParams.ads_label?.length ? filterParams.ads_label : []}
    //     />
    //   ),
    //   shortcut: true,
    // },
    {
      key: "adult",
      label: "Adult-Oriented Product",
      filter: (
        <Select
          label="Adult-Oriented Product"
          labelHidden
          options={[
            { label: "Yes", value: "Yes" },
            { label: "No", value: "No" },
          ]}
          placeholder="Choose Option..."
          onChange={(value) => handleFilterParams("adult", value)}
          value={filterParams.adult?.length ? filterParams.adult : []}
        />
      ),
      shortcut: true,
    },
    {
      key: "age_group",
      label: "Age Group",
      filter: (
        <Select
          label="Age Group"
          labelHidden
          options={[
            { label: "Not defined (blank)", value: "Not defined (blank)" },
          ]}
          placeholder="Select Age Group..."
          onChange={(value) => handleFilterParams("age_group", value)}
          value={filterParams.age_group?.length ? filterParams.age_group : []}
        />
      ),
      shortcut: true,
    },
    {
      key: "product_condition",
      label: "Condition",
      filter: (
        <Select
          label="Condition"
          labelHidden
          options={[
            { label: "Not defined (blank)", value: "Not defined (blank)" },
          ]}
          placeholder="Select Condition..."
          onChange={(value) => handleFilterParams("product_condition", value)}
          value={
            filterParams.product_condition?.length
              ? filterParams.product_condition
              : []
          }
        />
      ),
      shortcut: true,
    },
    {
      key: "color",
      label: "Color - Assigned for Feed",
      filter: (
        <TextField
          label="Color - Assigned for Feed"
          labelHidden
          // options={[
          //   { label: "Not defined (blank)", value: "Not defined (blank)" },
          // ]}
          placeholder="Select Color - Assigned for Feed..."
          onChange={(value) => handleFilterParams("color", value)}
          value={filterParams.color?.length ? filterParams.color : []}
        />
      ),
      shortcut: true,
    },
    {
      key: "default_cogs",
      label: "Custom Cost of Goods Sold (COGS)",
      filter: (
        <Select
          label="Custom Cost of Goods Sold (COGS)"
          labelHidden
          options={[
            { label: "Not defined (blank)", value: "Not defined (blank)" },
          ]}
          placeholder="Select Custom COGS..."
          onChange={(value) => handleFilterParams("default_cogs", value)}
          value={
            filterParams.default_cogs?.length ? filterParams.default_cogs : []
          }
        />
      ),
      shortcut: true,
    },
    {
      key: "customLabel0",
      label: "Custom Label 0",
      filter: (
        <TextField
          label="Custom Label 0"
          labelHidden
          placeholder="Type Custom Label..."
          onChange={(value) => handleFilterParams("customLabel0", value)}
          value={
            filterParams.customLabel0?.length ? filterParams.customLabel0 : []
          }
        />
      ),
      shortcut: true,
    },
    {
      key: "customLabel1",
      label: "Custom Label 1",
      filter: (
        <TextField
          label="Custom Label 1"
          labelHidden
          placeholder="Type Custom Label..."
          onChange={(value) => handleFilterParams("customLabel1", value)}
          value={
            filterParams.customLabel1?.length ? filterParams.customLabel1 : []
          }
        />
      ),
      shortcut: true,
    },
    {
      key: "customLabel2",
      label: "Custom Label 2",
      filter: (
        <TextField
          label="Custom Label 2"
          labelHidden
          placeholder="Type Custom Label..."
          onChange={(value) => handleFilterParams("customLabel2", value)}
          value={
            filterParams.customLabel2?.length ? filterParams.customLabel2 : []
          }
        />
      ),
      shortcut: true,
    },
    {
      key: "customLabel3",
      label: "Custom Label 3",
      filter: (
        <TextField
          label="Custom Label 3"
          labelHidden
          placeholder="Type Custom Label..."
          onChange={(value) => handleFilterParams("customLabel3", value)}
          value={
            filterParams.customLabel3?.length ? filterParams.customLabel3 : []
          }
        />
      ),
      shortcut: true,
    },
    {
      key: "customLabel4",
      label: "Custom Label 4",
      filter: (
        <TextField
          label="Custom Label 4"
          labelHidden
          placeholder="Type Custom Label..."
          onChange={(value) => handleFilterParams("customLabel4", value)}
          value={
            filterParams.customLabel4?.length ? filterParams.customLabel4 : []
          }
        />
      ),
      shortcut: true,
    },
    {
      key: "publishing_error",
      label: "Error from Merchant Center",
      filter: (
        <Select
          label="Error from Merchant Center"
          labelHidden
          options={[
            { label: "Not defined (blank)", value: "Not defined (blank)" },
          ]}
          placeholder="Select Publishing Error..."
          onChange={(value) => handleFilterParams("publishing_error", value)}
          value={
            filterParams.publishing_error?.length
              ? filterParams.publishing_error
              : []
          }
        />
      ),
      shortcut: true,
    },
    {
      key: "gender",
      label: "Gender",
      filter: (
        <Select
          label="Gender"
          labelHidden
          options={[
            { label: "Not defined (blank)", value: "Not defined (blank)" },
          ]}
          placeholder="Select Gender..."
          onChange={(value) => handleFilterParams("gender", value)}
          value={filterParams.gender?.length ? filterParams.gender : []}
        />
      ),
      shortcut: true,
    },
    {
      key: "google_product_category",
      label: "Google Product Categories",
      filter: (
        <Select
          label="Google Product Categories"
          labelHidden
          options={[
            { label: "Not defined (blank)", value: "Not defined (blank)" },
          ]}
          placeholder="Select Google Product Categories..."
          onChange={(value) =>
            handleFilterParams("google_product_category", value)
          }
          value={
            filterParams.google_product_category?.length
              ? filterParams.google_product_category
              : []
          }
        />
      ),
      shortcut: true,
    },
    {
      key: "default_material",
      label: "Material - Assigned for Feed",
      filter: (
        <Select
          label="Material - Assigned for Feed"
          labelHidden
          options={[
            { label: "Not defined (blank)", value: "Not defined (blank)" },
          ]}
          placeholder="Select Material..."
          onChange={(value) => handleFilterParams("default_material", value)}
          value={
            filterParams.default_material?.length
              ? filterParams.default_material
              : []
          }
        />
      ),
      shortcut: true,
    },
    {
      key: "default_pattern",
      label: "Pattern - Assigned for Feed",
      filter: (
        <Select
          label="Pattern - Assigned for Feed"
          labelHidden
          options={[
            { label: "Not defined (blank)", value: "Not defined (blank)" },
          ]}
          placeholder="Select Pattern..."
          onChange={(value) => handleFilterParams("default_pattern", value)}
          value={
            filterParams.default_pattern?.length
              ? filterParams.default_pattern
              : []
          }
        />
      ),
      shortcut: true,
    },
    {
      key: "custom_product",
      label: "Product Identifiers Control",
      filter: (
        <Select
          label="Product Identifiers Control"
          labelHidden
          options={[
            { label: "Not defined (blank)", value: "Not defined (blank)" },
          ]}
          placeholder="Select Product Identifiers Control..."
          onChange={(value) => handleFilterParams("custom_product", value)}
          value={
            filterParams.custom_product?.length
              ? filterParams.custom_product
              : []
          }
        />
      ),
      shortcut: true,
    },
    {
      key: "product_type",
      label: "Product Type",
      filter: (
        <Select
          label="Product Type"
          labelHidden
          options={[
            { label: "Not defined (blank)", value: "Not defined (blank)" },
          ]}
          placeholder="Select Product Type..."
          onChange={(value) => handleFilterParams("product_type", value)}
          value={
            filterParams.product_type?.length ? filterParams.product_type : []
          }
        />
      ),
      shortcut: true,
    },
    {
      key: "brand",
      label: "Vendor (Brand)",
      filter: (
        <Select
          label="Vendor (Brand)"
          labelHidden
          options={[
            { label: "Not defined (blank)", value: "Not defined (blank)" },
          ]}
          placeholder="Select Vendor (Brand)..."
          onChange={(value) => handleFilterParams("brand", value)}
          value={filterParams.brand?.length ? filterParams.brand : []}
        />
      ),
      shortcut: true,
    },
  ];

  const appliedFilters = [];

  const filterKeys = {
    // ads_grouping: "Ads Grouping",
    // ads_label: "Ads Label",
    adult: "Adult-Oriented Product",
    age_group: "Age Group",
    product_condition: "Condition",
    color: "Color - Assigned for Feed",
    default_cogs: "Custom Cost of Goods Sold (COGS)",

    customLabel0: "Custom Label 0",
    customLabel1: "Custom Label 1",
    customLabel2: "Custom Label 2",
    customLabel3: "Custom Label 3",
    customLabel4: "Custom Label 4",

    publishing_error: "Error from Merchant Center",
    gender: "Gender",
    google_product_category: "Google Product Categories",
    default_material: "Material - Assigned for Feed",
    default_pattern: "Pattern - Assigned for Feed",
    custom_product: "Product Identifiers Control",
    product_type: "Product Type",
    channel_submission_control: "Product Submission Control",
    promotions: "Promotion",
    return_policy_label: "Return Policy Label",
    shipping_label: "Shipping Label",
    default_size: "Size - Assigned for Feed",
    size_system: "Size System",
    size_type: "Size Type",
    tags: "Tag",
    unit_pricing_measure: "Unit Pricing Measure",
    unit_pricing_base_measure: "Unit Pricing Base Measure",
    brand: "Vendor (Brand)",
  };

  const customLabelKeys = [
    "customLabel0",
    "customLabel1",
    "customLabel2",
    "customLabel3",
    "customLabel4",
  ];
  // Loop through the filter keys to dynamically create applied filters
  Object.keys(filterKeys).forEach((key) => {
    if (filterParams[key] && !isEmpty(filterParams[key])) {
      appliedFilters.push({
        key,
        label: `${filterKeys[key]} ${
          customLabelKeys.includes(key) ? "contains" : "is"
        } "${filterParams[key]}"`,
        onRemove: () => handleFilterParams(key, []),
      });
    }
  });

  const handleFiltersClearAll = useCallback(() => {
    setFilterParams({
      // ads_grouping: [],
      // ads_label: [],
      adult: [],
      age_group: [],
      product_condition: [],
      color: [],
      default_cogs: [],
      customLabel0: [],
      customLabel1: [],
      customLabel2: [],
      customLabel3: [],
      customLabel4: [],
      publishing_error: [],
      gender: [],
      google_product_category: [],
      default_material: [],
      default_pattern: [],
      custom_product: [],
      product_type: [],
      channel_submission_control: [],
      promotions: [],
      return_policy_label: [],
      shipping_label: [],
      default_size: [],
      size_system: [],
      size_type: [],
      tags: [],
      unit_pricing_measure: [],
      unit_pricing_base_measure: [],
      brand: [],
    });
    setQueryValue("");
    setSortSelected(["product asc"]);
    setProducts([]);
    fetchProducts();
  }, [setFilterParams]);

  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }

  const onHandleCancel = () => {
    setFilterParams({
      // ads_grouping: [],
      // ads_label: [],
      adult: [],
      age_group: [],
      product_condition: [],
      color: [],
      default_cogs: [],
      customLabel0: [],
      customLabel1: [],
      customLabel2: [],
      customLabel3: [],
      customLabel4: [],
      publishing_error: [],
      gender: [],
      google_product_category: [],
      default_material: [],
      default_pattern: [],
      custom_product: [],
      product_type: [],
      channel_submission_control: [],
      promotions: [],
      return_policy_label: [],
      shipping_label: [],
      default_size: [],
      size_system: [],
      size_type: [],
      tags: [],
      unit_pricing_measure: [],
      unit_pricing_base_measure: [],
      brand: [],
    });
    setQueryValue("");
    setSortSelected(["product asc"]);
    setProducts([]);
    fetchProducts();
  };

  const tabWithBadges = [
    {
      label: "All Products",
      badge: activeProductsCount || allFeedProducts.length,
    },
    { label: "Errors", badge: ineligibleProducts.length },
    { label: "Submitted", badge: submittedProducts.length },
    { label: "Excluded", badge: excludedProducts.length },
    { label: "Already Listed", badge: alreadyListedProducts.length },
  ];

  const redirectToProductDetailsPage = (data) => {
    navigate(`/product-detail?shop=${paramValue}`, {
      state: { product: data },
    });
  };

  const tabs = tabWithBadges.map((item, idx) => ({
    content: item.label,
    id: idx.toString(),
    badge: item.badge || "0",
  }));

  const { selectedResources, allResourcesSelected, handleSelectionChange } =
    useIndexResourceState(products);

  // Helper to merge Google MC errors into product arrays
  function mergeProductErrors(productArray, errorMap) {
    return productArray.map((prod) => {
      // If this product has variants, map errors for each variant
      if (
        prod.variants &&
        prod.variants.edges &&
        prod.variants.edges.length > 0
      ) {
        // Optionally, you can aggregate errors for all variants, or just the first
        const variantErrors = prod.variants.edges
          .map((v) => {
            const variantId = v.node.id.split("/").pop();
            return errorMap[variantId] || [];
          })
          .flat();
        if (variantErrors.length > 0) {
          return {
            ...prod,
            errors: [...(prod.errors || []), ...variantErrors],
          };
        }
      }
      // fallback to product id (if needed)
      const shopifyId = prod.id.split("/").pop();
      const errors = errorMap[shopifyId];
      if (errors && errors.length > 0) {
        return {
          ...prod,
          errors: [...(prod.errors || []), ...errors],
        };
      }
      return prod;
    });
  }

  const fetchProductErrorsAndMerge = async () => {
    try {
      const errorRes = await fetch(
        `${process.env.REACT_APP_API_URL}/api/google/product-errors?shop=${paramValue}`,
      );
      const errorData = await errorRes.json();

      if (!errorRes.ok) {
        const migrationMessage = errorData.error?.message?.includes(
          "registered",
        )
          ? "Merchant API is not registered for this Merchant Center account."
          : errorData.error?.message ||
            "Unable to load Google product diagnostics.";
        setBanners((prev) => [
          {
            status: "warning",
            title: "Google diagnostics unavailable",
            content: migrationMessage,
          },
          ...prev.filter(
            (banner) => banner.title !== "Google diagnostics unavailable",
          ),
        ]);
        return;
      }

      if (errorData?.data?.errors) {
        // Build error map: { shopifyId: [ {type, description, detail, documentation} ] }
        const errorMap = {};
        errorData.data.errors.forEach((prod) => {
          const shopifyId = prod.productId.split(":").pop();
          const allErrors = [
            ...(prod.itemLevelIssues || []).map((issue) => ({
              type: "item",
              description:
                issue.description ||
                issue.type?.code ||
                "Merchant API item issue",
              detail: issue.detail || issue.resolution,
              documentation: issue.documentation || null,
            })),
            ...(prod.productLevelIssues || []).map((issue) => ({
              type: "product",
              description:
                issue.description ||
                issue.type?.code ||
                "Merchant API product issue",
              detail: issue.detail || issue.resolution,
              documentation: issue.documentation || null,
            })),
          ];
          if (allErrors.length > 0) errorMap[shopifyId] = allErrors;
        });
        setProducts((prev) => mergeProductErrors(prev, errorMap));
        setSubmittedProducts((prev) => mergeProductErrors(prev, errorMap));
        setExcludedProducts((prev) => mergeProductErrors(prev, errorMap));
        setIneligibleProducts((prev) => mergeProductErrors(prev, errorMap));
        setAllFeedProducts((prev) => mergeProductErrors(prev, errorMap));
      }
    } catch (error) {
      console.error("Error fetching product errors:", error);
    }
  };

  const openErrorModal = (product) => {
    setSelectedProduct(product);
    setSelectedErrors(product.errors || []);
    setSelectedWarnings(product.warnings || []);
    setErrorModalOpen(true);
  };

  const closeErrorModal = () => {
    setErrorModalOpen(false);
    setSelectedErrors([]);
    setSelectedWarnings([]);
    setSelectedProduct(null);
  };

  const getFeedStatusBadge = (feedStatus, productData = {}) => {
    const badges = [];

    if (productData.alreadyOnGmc) {
      badges.push(
        <Badge key="gmc" tone="info">
          Already on GMC
        </Badge>,
      );
    }

    switch (feedStatus) {
      case "submitted":
        badges.push(
          <Badge key="feed" tone="success">
            Synced by app
          </Badge>,
        );
        break;
      case "excluded":
        badges.push(
          <Badge key="feed" tone="warning">
            Excluded
          </Badge>,
        );
        break;
      case "ineligible":
        badges.push(
          <Badge key="feed" tone="critical">
            Needs fixes
          </Badge>,
        );
        break;
      default:
        if (!productData.alreadyOnGmc) {
          badges.push(<Badge key="feed">Not synced</Badge>);
        }
        break;
    }

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {badges}
      </div>
    );
  };

  const getSyncActionLabel = (feedStatus) => {
    return feedStatus === "submitted" ? "Resync" : "Sync";
  };

  const splitProductTitle = (title = "") => {
    const text = String(title || "").trim();
    if (!text) return { prefix: "", emphasis: "Untitled product" };

    const slashIdx = text.indexOf("/");
    if (slashIdx > 0 && slashIdx < text.length - 1) {
      return {
        prefix: text.slice(0, slashIdx + 1),
        emphasis: text.slice(slashIdx + 1).trim(),
      };
    }

    const dashIdx = text.indexOf(" - ");
    if (dashIdx > 0 && dashIdx < text.length - 3) {
      return {
        prefix: `${text.slice(0, dashIdx)} - `,
        emphasis: text.slice(dashIdx + 3).trim(),
      };
    }

    const parenIdx = text.indexOf(" (");
    if (parenIdx > 0) {
      return {
        prefix: `${text.slice(0, parenIdx)} `,
        emphasis: text.slice(parenIdx + 1).trim(),
      };
    }

    return { prefix: "", emphasis: text };
  };

  const getProductSku = (productData = {}) => {
    const edges = productData?.variants?.edges || [];
    for (const edge of edges) {
      const sku = edge?.node?.sku;
      if (sku) return String(sku);
    }
    return "";
  };

  const rowMarkup = (productsArray, exclude = null) => {
    return productsArray.map((productData, index) => {
      const { id, product, category, errors, image, tooltip } = productData;
      let submitted = productData.feedStatus === "submitted";
      if (exclude != null) {
        submitted = exclude;
      }
      const { prefix, emphasis } = splitProductTitle(product);
      const sku = getProductSku(productData);
      const numericId = id ? String(id).split("/").pop() : "";
      return (
        <IndexTable.Row
          id={id}
          key={`${id}-${index}`}
          selected={selectedResources.includes(id)}
          position={index}
        >
          <IndexTable.Cell>
            <Thumbnail
              source={image || undefined}
              alt={image ? product : ""}
            />
          </IndexTable.Cell>
          <IndexTable.Cell>
            <div className="products-table__product-name">
              <Link onClick={() => redirectToProductDetailsPage(productData)}>
                <span className="products-table__title">
                  {prefix ? (
                    <span className="products-table__title-prefix">
                      {prefix}
                    </span>
                  ) : null}
                  <span className="products-table__title-emphasis">
                    {emphasis}
                  </span>
                </span>
              </Link>
              <div className="products-table__product-subline">
                {sku ? <span>SKU: {sku}</span> : null}
                {sku && numericId ? <span aria-hidden="true">·</span> : null}
                {numericId ? <span>ID: {numericId}</span> : null}
                {!sku && !numericId && category ? (
                  <span>{category}</span>
                ) : null}
              </div>
              <div className="products-table__product-meta">
                {productData.alreadyOnGmc ? (
                  <Badge tone="info" size="small">
                    Already on GMC
                  </Badge>
                ) : null}
                {productData.feedStatus === "submitted" ? (
                  <Badge tone="success" size="small">
                    Synced by app
                  </Badge>
                ) : null}
                {productData.feedStatus === "excluded" ? (
                  <Badge tone="warning" size="small">
                    Excluded
                  </Badge>
                ) : null}
                {productData.feedStatus === "ineligible" ? (
                  <Badge tone="critical" size="small">
                    Needs fixes
                  </Badge>
                ) : null}
                {!productData.alreadyOnGmc &&
                productData.feedStatus !== "submitted" &&
                productData.feedStatus !== "excluded" &&
                productData.feedStatus !== "ineligible" ? (
                  <Badge size="small">Not synced</Badge>
                ) : null}
              </div>
            </div>
          </IndexTable.Cell>
          <IndexTable.Cell position="center">
            <div>{""}</div>
          </IndexTable.Cell>
          {(bulkLoading && selectedResources.includes(id)) || refreshError ? (
            <IndexTable.Cell>
              <Spinner
                accessibilityLabel="Small spinner example"
                size="small"
              />
            </IndexTable.Cell>
          ) : (
            <IndexTable.Cell>
              {errors && errors.length > 0 ? (
                <span
                  style={{
                    color: "red",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  onClick={() => openErrorModal(productData)}
                >
                  <img
                    src={warningIcon}
                    alt="Issues"
                    style={{ width: 16, marginRight: 4 }}
                  />
                  {errors.length} issue{errors.length > 1 ? "s" : ""}
                </span>
              ) : (
                <span>
                  <img
                    src={checkedIcon}
                    alt="No Issues"
                    style={{ width: 16, marginRight: 4 }}
                  />
                  No issues
                </span>
              )}
            </IndexTable.Cell>
          )}
          {(bulkLoading && selectedResources.includes(id)) || refreshError ? (
            <IndexTable.Cell>
              <div className="orange-loader" />
            </IndexTable.Cell>
          ) : (
            <IndexTable.Cell>
              <div style={{ marginBottom: "6px" }}>
                {getFeedStatusBadge(productData.feedStatus, productData)}
              </div>
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <img
                  src={icon}
                  alt="Google"
                  style={{ width: "16px", height: "16px" }}
                />
                {errors && errors.length > 0 ? (
                  <Tooltip content={errors[0] || "Needs attention"}>
                    <img
                      src={warningIcon}
                      alt="Needs attention"
                      style={{ width: "16px", height: "16px" }}
                    />
                  </Tooltip>
                ) : (
                  <Tooltip
                    content={
                      submitted
                        ? "Synced successfully"
                        : productData.alreadyOnGmc
                          ? "Already listed on Google Merchant Center"
                          : "Ready for Shopping Channels"
                    }
                  >
                    <img
                      src={checkedIcon}
                      alt="OK"
                      style={{ width: "16px", height: "16px" }}
                    />
                  </Tooltip>
                )}
              </div>
            </IndexTable.Cell>
          )}
          <IndexTable.Cell>
            <Button
              size="slim"
              onClick={() => handleSyncProducts({ productIds: [id] })}
              loading={syncingProductId === id}
              disabled={syncLoading && syncingProductId !== id}
            >
              {getSyncActionLabel(productData.feedStatus)}
            </Button>
          </IndexTable.Cell>
        </IndexTable.Row>
      );
    });
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const emptyRow = () => {
    return [];
  };

  const getCurrentTabProducts = () => {
    switch (selected) {
      case 0:
        return allFeedProducts;
      case 1:
        return ineligibleProducts;
      case 2:
        return submittedProducts;
      case 3:
        return excludedProducts;
      case 4:
        return alreadyListedProducts;
      default:
        return [];
    }
  };

  const currentTabProducts = getCurrentTabProducts();
  const showingCount = currentTabProducts.length;
  const totalCount =
    selected === 0
      ? activeProductsCount || showingCount
      : selected === 4
        ? gmcImportSummary?.matchedShopifyProducts ||
          gmcImportSummary?.matchedProducts ||
          showingCount
        : showingCount;

  const renderProducts = () => {
    switch (selected) {
      case 0:
        return rowMarkup(allFeedProducts);
      case 1:
        return rowMarkup(ineligibleProducts);
      case 2:
        return rowMarkup(submittedProducts);
      case 3:
        return rowMarkup(excludedProducts, false);
      case 4:
        return rowMarkup(alreadyListedProducts);
      default:
        return [];
    }
  };

  const handleExcludeProducts = async (selectedProducts) => {
    try {
      setBulkLoading(true);
      // Construct the URL with the query parameter
      const urlParams = new URLSearchParams(location.search);
      const paramValue = urlParams.get("shop");
      const url = `${process.env.REACT_APP_API_URL}/api/shopify/store/products/exclude?shop=${paramValue}`;

      // if (excludedProducts.length > 0) {
      //   newProducts = excludedProducts.filter((obj) => {
      //     return selectedProducts.map((prod) => {
      //       if (prod.id != obj.id) {
      //         return true;
      //       }
      //     });
      //   });
      // }

      // Make the POST request
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ products: selectedProducts }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      let newProducts = [];
      products.forEach((prod) => {
        if (selectedProducts.includes(prod.id)) {
          newProducts.push(prod);
        }
      });

      let newSubmittedProd = [];
      submittedProducts.forEach((prod) => {
        if (!selectedProducts.includes(prod.id)) {
          newSubmittedProd.push(prod);
        }
      });

      // Update excludedProducts state by spreading newProducts
      setExcludedProducts((prevProd) => [...prevProd, ...newProducts]);
      setSubmittedProducts(() => [...newSubmittedProd]);
      setBulkLoading(false);
      return data;
    } catch (error) {
      setBulkLoading(false);
      console.error("Error excluding products:", error);
      throw error;
    }
  };

  const bulkEditProducts = async (selectedProducts, obj) => {
    setBulkLoading(true);
    const urlParams = new URLSearchParams(location.search);
    const paramValue = urlParams.get("shop");
    const url = `${process.env.REACT_APP_API_URL}/api/shopify/store/products/update?shop=${paramValue}`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ products: selectedProducts, title: obj }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    setBulkLoading(false);
    return;
  };

  const getTitle = (title) => {
    switch (title) {
      // case "Assign Ads Grouping":
      //   return "adsGrouping";
      // case "Assign Ads Label":
      //   return "adsLabels";
      case "Assign Color for Feed":
        return "color";
      // case "Assign Cost of Goods Sold for Feed":
      //   return "costOfGoodsSold";
      case "Assign Custom Label 0":
        return "customLabel0";
      case "Assign Custom Label 1":
        return "customLabel1";
      case "Assign Custom Label 2":
        return "customLabel2";
      case "Assign Custom Label 3":
        return "customLabel3";
      case "Assign Custom Label 4":
        return "customLabel4";
      case "Assign Material for Feed":
        return "material";
      case "Assign Patern for Feed":
        return "pattern";
      case "Assign Shipping Label":
        return "shippingLabel";
      case "Assign Tax Category":
        return "taxCategory";
      default:
        return "";
    }
  };
  const breakpoints = useBreakpoints();
  return (
    <>
      <Page fullWidth>
        <div
          style={{
            marginBottom: "12px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          <Button
            onClick={async () => {
              const result = await handleImportGmcProducts({ force: true });
              if (result) {
                await fetchProducts(null, null, false);
              }
            }}
            loading={gmcImportLoading}
            disabled={gmcImportLoading || syncLoading}
          >
            Check GMC listings
          </Button>
          <Button
            variant="primary"
            onClick={() => handleSyncProducts({ syncAll: true })}
            loading={syncLoading && !syncingProductId}
            disabled={syncLoading || gmcImportLoading}
          >
            Sync All Products
          </Button>
        </div>
        {gmcImportSummary ? (
          <div style={{ marginBottom: "10px" }}>
            <Banner tone="info" title="Already listed on Google Merchant Center">
              <p>
                Your store has{" "}
                <strong>
                  {gmcImportSummary.activeShopifyProductCount ||
                    gmcImportSummary.shopifyProductCount ||
                    activeProductsCount ||
                    "—"}
                </strong>{" "}
                Active Shopify products.{" "}
                <strong>
                  {gmcImportSummary.matchedShopifyProducts ||
                    gmcImportSummary.matchedProducts ||
                    0}
                </strong>{" "}
                of them are already listed on GMC (from another app or feed).
                GMC currently has{" "}
                <strong>{gmcImportSummary.gmcTotal || 0}</strong> offers total
                {gmcImportSummary.unmatchedGmcOffers ||
                gmcImportSummary.unmatchedOffers
                  ? `, and ${
                      gmcImportSummary.unmatchedGmcOffers ||
                      gmcImportSummary.unmatchedOffers
                    } could not be matched to Shopify`
                  : ""}
                .
              </p>
            </Banner>
          </div>
        ) : null}
        {banners.length > 0 &&
          banners.map((banner) => (
            <div style={{ marginBottom: "10px" }}>
              <Banner
                tone={banner.status}
                title={banner.title}
                status={banner.status}
                onDismiss={() => handleDismissBanner(banner)}
              >
                <p>{banner.content}</p>
              </Banner>
            </div>
          ))}
        {isProcessing && (
          <Banner tone="info" title="Processing">
            Your request to sync meta fields for all products has been received
            and is currently under processing. During this you cannot re-sync
            feed or modify product information from the app.
          </Banner>
        )}

        <IndexFilters
          // sortOptions={sortOptions}
          // sortSelected={sortSelected}
          queryValue={queryValue}
          queryPlaceholder="Search products"
          onQueryChange={handleFiltersQueryChange}
          onQueryClear={() => setQueryValue("")}
          onSort={setSortSelected}
          cancelAction={{
            onAction: onHandleCancel,
            disabled: false,
            loading: false,
          }}
          canCreateNewView={false}
          tabs={tabs}
          selected={selected}
          onSelect={(index) => {
            setTabLoading(true);
            setTimeout(() => {
              setSelected(index);
              setTabLoading(false);
            }, 1000);
          }}
          filters={filters}
          appliedFilters={appliedFilters}
          onClearAll={handleFiltersClearAll}
          mode={mode}
          setMode={setMode}
        />
        {tabLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "40px 0",
            }}
          >
            <Spinner size="large" accessibilityLabel="Loading tab..." />
          </div>
        ) : (
          <div className="products-index-table">
            <IndexTable
              condensed={breakpoints.smDown}
              // Conditionally disable bulk actions and selection
              bulkActions={selected === 1 || selected === 2 ? null : bulkActions} // Disable for Ineligible (1) and Excluded (3)
              resourceName={resourceName}
              itemCount={showingCount}
              selectedItemsCount={
                selected === 1 || selected === 2 // Disable for Ineligible (1) and Excluded (3)
                  ? undefined
                  : allResourcesSelected
                    ? "All Products"
                    : selectedResources.length
              }
              onSelectionChange={
                selected === 1 || selected === 2
                  ? undefined
                  : handleSelectionChange // Disable for Ineligible (1) and Excluded (3)
              }
              headings={headings}
              loading={loading}
              pagination={
                selected === 0
                  ? {
                      hasNext: hasNextPage,
                      onNext: handleNextPage,
                    }
                  : undefined
              }
            >
              {renderProducts()}
            </IndexTable>
            <div className="products-table-footer">
              <span>
                Showing <strong>{showingCount}</strong> of{" "}
                <strong>{totalCount}</strong>{" "}
                {selected === 0 ? "Active products" : "products"}
              </span>
              {selected === 0 && hasNextPage ? (
                <span>Scroll or use Next to load more</span>
              ) : null}
            </div>
          </div>
        )}
      </Page>
      {openModal && (
        <div style={{ height: "500px" }}>
          <Frame>
            <Modal
              // activator={activator}
              open={openModal}
              onClose={handleCloseModal}
              title={modal.title}
              primaryAction={{
                content: "Apply in bulk",
                onAction: () => {
                  if (modal.title == "Exclude Products") {
                    handleExcludeProducts(selectedResources);
                  } else {
                    let title = getTitle(modal.title);
                    let obj = {};
                    obj[title] = textFieldValue;
                    bulkEditProducts(selectedResources, obj);
                  }
                  setOpenModal(false);
                  setModal(null);
                },
              }}
              secondaryActions={[
                {
                  content: "Cancel",
                  onAction: () => {
                    setOpenModal(false);
                    setModal(null);
                  },
                },
              ]}
            >
              <Modal.Section>
                {modal.inputField ? (
                  <TextField
                    // label="Shipping zone name"
                    value={textFieldValue}
                    onChange={handleTextFieldChange}
                    // placeholder="Example: North America, Europe"
                    autoComplete="off"
                  />
                ) : (
                  <TextContainer>
                    <p>{modal.content}</p>
                  </TextContainer>
                )}
              </Modal.Section>
            </Modal>
          </Frame>
        </div>
      )}
      {/* Error Details Modal */}
      <Modal
        open={errorModalOpen}
        onClose={closeErrorModal}
        title={
          selectedProduct
            ? `Issues for ${selectedProduct.product}`
            : "Product Issues"
        }
        primaryAction={{
          content: "Close",
          onAction: closeErrorModal,
        }}
      >
        <Modal.Section>
          {selectedErrors.length === 0 && selectedWarnings.length === 0 ? (
            <Text>No issues found for this product.</Text>
          ) : (
            <>
              {selectedErrors.length > 0 && (
                <div style={{ marginBottom: 12 }}>
                  <div
                    style={{
                      fontWeight: 600,
                      marginBottom: 6,
                      color: "#c0392b",
                    }}
                  >
                    Errors
                  </div>
                  {selectedErrors.map((err, i) => (
                    <div
                      key={`err-${i}`}
                      style={{
                        marginBottom: 12,
                        paddingBottom: 8,
                        borderBottom: "1px solid #eee",
                      }}
                    >
                      {typeof err === "object" ? (
                        <>
                          <div style={{ margin: "4px 0" }}>
                            {err.description || err.detail || "Unknown error"}
                          </div>
                          {err.detail && (
                            <div style={{ color: "#555", fontSize: 13 }}>
                              {err.detail}
                            </div>
                          )}
                          {err.documentation && (
                            <div>
                              <a
                                href={err.documentation}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#007bff" }}
                              >
                                Learn More
                              </a>
                            </div>
                          )}
                        </>
                      ) : (
                        <div style={{ margin: "4px 0" }}>{String(err)}</div>
                      )}
                    </div>
                  ))}
                </div>
              )}
              {selectedWarnings.length > 0 && (
                <div>
                  <div
                    style={{
                      fontWeight: 600,
                      marginBottom: 6,
                      color: "#f39c12",
                    }}
                  >
                    Warnings
                  </div>
                  {selectedWarnings.map((warn, i) => (
                    <div key={`warn-${i}`} style={{ marginBottom: 8 }}>
                      {String(warn)}
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </Modal.Section>
      </Modal>
    </>
  );
}

export default DataTable3;
